export class LogData {
  /**
   * @callback FilterCallback
   * @param {Record<string, unknown>} item - строка таблицы
   * @returns {string}
   */
  /**
   *
   * @param {Record<string, unknown>[]} tableData - данные таблицы
   * @param {(string | FilterCallback[])} filters - набор фильтров
   * @param {string} search - строка поиска
   * @returns {Record<string, unknown>[]}
   */
  static filterTable(tableData, filters, search) {
    const searchLowercased = (search || '').toLowerCase();

    if (!filters.length) return tableData;

    return tableData.filter((item) => {
      const filterResults = filters.map((filter) => {
        const itemToCheckIncludes = typeof filter === 'function' ? filter(item) : `${item[filter]}`;

        return (itemToCheckIncludes || '').toLowerCase().includes(searchLowercased);
      });

      return filterResults.includes(true);
    });
  }

  static filterStatData(data, search) {
    const searchLower = (search || '').toLowerCase();
    const matchesSearch = (event) => (event.link || '').toLowerCase().includes(searchLower);

    return (data || [])
      .map((user) => ({
        ...user,
        history: Object.fromEntries(
          Object.entries(user.history || {})
            .map(([key, category]) => ({
              key,
              value: {
                ...category,
                events: (category.events || []).filter(matchesSearch),
              },
            }))
            .filter(({ value }) => (value.events || []).length > 0)
            .map(({ key, value }) => [key, value]),
        ),
      }))
      .filter((user) => Object.keys(user.history || {}).length > 0);
  }
}
